export default {
  header: 'Administer',
  auditTrail: {
    title: 'Audit Trail',
    function: 'Function',
    user: 'User',
    actionDetail: 'Action Detail',
    actionDate: 'Action Date',

  },
  bulletin: {
    title: 'Bulletin',
    category: 'Category',
    header: 'Bulletin List',
    policyType: 'Policy Type',
    provider: 'Provider',
    bulletinList: 'List',
    create: 'Create Bulletin',
    edit: 'Edit',
    view: 'View',
    attachment: 'Attachment',
    deleteConfirmTitle: 'Are you sure to DELETE the bulletin with details below?',
    subject: 'Subject',
    content: 'Content',
    createTime: 'Create Time',
    updateTime: 'Edit Time',
    preview: 'Preview',
  },

  agent: {
    ID: 'ID',
    agentList: 'List',
    create: 'Create FC',
    success: 'Create / Edit success',
    confirmation: 'Are you sure to edit / create FC?',
    header: 'Financial Consultant',
    agentInformation: 'FC Information',
    agentCode: 'FC Code',
    joinDate: 'Join Date',
    leaveDate: 'Leave Date',
    agentTeam: 'FC Team',
    position: 'Position',
    name: 'FC Name',
    cibLicense: 'CIB License',
    mpfaLicense: 'MPFA License',
    managerOverrideRate: 'Manager Override Rate',
    ociLicensePrinciples: 'OCI License Principles',
    ociLicenseGeneral: 'OCI License General',
    ociLicenseLongTerm: 'OCI License Long Term',
    ociLicenseLinkedLongTerm: 'OCI License Linked Long Term',

    sfcLicenseType1: 'SFC License T1',
    sfcLicenseType2: 'SFC License T2',
    sfcLicenseType3: 'SFC License T3',
    sfcLicenseType4: 'SFC License T4',
    sfcLicenseType5: 'SFC License T5',
    sfcLicenseType6: 'SFC License T6',
    sfcLicenseType7: 'SFC License T7',
    sfcLicenseType8: 'SFC License T8',
    sfcLicenseType9: 'SFC License T9',
    sfcLicenseType10: 'SFC License T10',

    userEmail: 'User Email',
    language: 'Prefered System Language',
    marketingOptOut: 'Marketing Opt Out',
    license: 'License Information',
    noAgentTeam: 'No FC Team',
    hasAgentTeam: 'Has FC Team',
    search: 'Search FC',
    create: 'Create FC',
    contactType: 'Contact Type',
    idType: 'ID Type',
    maritalStatus: 'Marital Status',

    parentAgent: 'Parent FC',
    providerSplitRate: 'Provider Split Rates',
    fyc: 'FYC',
    provider: 'Provider',
    commission: '2+ Year Commission',
    defaultSplitRate: {
      header: 'Default Override Split Rate',
    },
    editSplitRate: 'Edit Provider Specific Split Rate',
    cancelSplitRate: 'Cancel Override Provider Specific Split Rate',
    overrideSplitRate: 'Override All Provider Split Rate',
    noParentAgent: 'No Parent FC',
    hasParentAgent: 'Has Parent FC',

    agentSplitModal: {
      editAgentSplitRate: 'Edit Provider Specific Split Rate',
      editAgentSplitRateBody: 'Editing provider specific split rate will only affect a specific provider',
      overrideAgentSplitRate: 'Override All Provider Split Rate',
      overrideAgentSplitRateBody: 'Overrding split rate will affect all provider rate related to this FC'
    }
  },

  document: {
    listTitle: 'Document Management',
    download: 'Download',
    remove: 'Remove',
    fields: {
      'ID': 'ID',
      'documentName': 'Document Name',
      'linkedEntity': 'Linked Entity',
      'fileSize': 'File Size',
      'documentType': 'Document Type',
      'publicDocument': 'Public Document',
      'documentTag': 'Document Tag',
      'remarks': 'Remarks',
      'createTime': 'Create Time',
      'createUser': 'Create User',
      'actions': 'Actions',
    }
  },

  product: {
    list: {
      title: 'Product Management',
      search: 'Search Product',

    },
    create: {
      successMsg: 'Product create successfully',
      title: 'Create Product',
    },
  },

  contents: {
    EntityManagement: {
      title: 'Entity Management',
      search: "Search",
      perPage: 'Per Page',
      total: 'Total',
      records: 'Records',
      createBtn: 'Create New',

      // Core Session
      Core: {
        header: 'Core Entity',
        name: 'CORE',
        contact: { title: 'Contact', },
        customer: { title: 'Customer', },
        address: { title: 'Address', },
        agent: { title: 'FC', },
        lead: { title: 'Lead', },
        message: { title: 'Message', },
        user: { title: 'User', },
        team: { title: 'Team' }
      },

      OSMLife: {
        header: 'OSM-Life Entity',
        name: 'OSM Life',
        product: { title: 'Product', },
        policy: { title: 'Policy', },
        policyPremium: { title: 'Policy Premium', },
        paymentHistory: { title: 'Payment History', },
        policyFund: { title: 'Policy Fund', },
        investmentStrategy: { title: 'Investment Strategy', },
        transactionHistory: { title: 'Transaction History', },
        outstandingRequirement: { title: 'outstandingRequirement' },
        outstandingRequirementComment: { title: 'OR Comment', },
        insuredBenefits: { title: 'Insured Benefits', },
        pendingOperation: { title: 'Pending Operation', },
        commission: { title: 'Commission', },
        commissionOverride: { title: 'Commission Override', },
      },

      OSMGI: {
        header: 'OSM-GI Entity',
        name: 'OSM - GI & Loan',
        generalPolicy: { title: 'General Policy' },
        loanContract: { title: 'Loan Contract' },
      },
      DM: {
        header: 'Document Management',
        name: 'DM',
        document: { title: 'Document' },
      },
      System: {
        name: 'System Management',
        systemLogs: { title: 'System Logs' },
        entitlement: { title: 'Entitlement' },
      },
      productManagement: {
        header: 'Product',
      },
    }
  },

  userAuthorization: {
    title: 'Authorization',
    header: 'User Authorization',

    change: {
      modal: {
        title: 'Are you sure to apply these changes',
        body: 'Changes will be made immidiatly after confirmation'
      },
      header: 'Change User Authorization',
      selectedCandidate: 'Selected User(s)',
      role: 'Role',
      applyChanges: 'Apply Changes'
    },
    list: {
      userType: 'User Type',
      referenceCode: 'Reference Code',
      success: 'Change User Authorization Success',
      error: 'Error on Changing User Authorization',
      edit: 'Edit',
      header: 'User Authorization List',
      englishName: 'English Name / 中文名',
      roleName: 'Role Name'
    }
  },
  team: {
    header: 'Team',
    list: 'List',
    teamCode: 'Team Code',
    leader: 'Leader',
    leaderCode: 'Leader FC Code',
    numberOfMember: 'Number of Memeber',
    createTeam: 'Create Team',
    editTeam: 'Edit Team',
    parentTeam: 'Parent Team',
    haveParentTeam: 'Have Parent Team?',
    addAgent: 'Add FC',
    removeAgent: 'Remove FC',
    addAgentComfirm: '<h4>Are you sure to <b>ADD</b> below FC to this team?</h4> <br/> <p>FC Name: {agentName}</p>',
    removeAgentComfirm: '<h4>Are you sure to <b>DELETE</b> below FC from this team?</h4> <br/> <p>FC Name: {agentName}</p>',
  },
  agentCommission: {
    header: 'FC Commission',
    payCommissionModal: {
      header: 'FC Commission',
      content: 'Please enter following information to confirm the payment of commission.',
      commissionDate: 'Commission Release Date',

      commissionActualReceived: 'Actual Commission Amount',
      faCommission: 'FC Commission',
    }
  },
  companyCommission: {
    header: 'Company Gross Commission',
    payCommissionModal: {
      content: 'Please enter following information to confirm the payment of gross commission.',
      header: 'Company Gross Commission',
      commissionDate: 'Commission Receive Date',
      commissionReceived: 'Gross Commission Received'
    },
    commissionWithheld: 'Gross Commission Withheld',
    commissionReceivable: 'Gross Commission Receivable',

    policyReference: 'Policy Reference',
    policyNumber: 'Policy Number',

  },
  cpd: {
    providerName: 'Provider Name',
    trainingName: 'Training Name',
    trainingType: 'Training Type',
    trainingDate: 'Training Date',
    trainingTime: 'Training Time',
    agent: 'Participant (FC)',
    addAgent: 'Add Participant (FC)',
    remove: 'Remove',
    create: 'Create',
    edit: 'Edit Training',
    cpd: 'CPD',
    point: 'Points',
    agentShortHeader: 'FC CPD',
    list: {
      shortHeader: 'Training List',
      providerName: 'Provider Name',
      trainingDate: 'Training Date',
      trainingName: 'Training Name',
      trainingType: 'Training Type',
      updateTime: 'Update Time',
      header: 'Training List',
      ID: 'ID',
      agentCode: 'FC Code',
      agentName: 'FC Name',
      mpfCorePoint: 'MPF Core Points',
      mpfNonCorePoint: 'MPF Non-Core Points',
      mpfPoint: 'MPF Total Points',
      normalPoint: 'Normal Points',
      nonCorePoint: 'Non-Core Points',
      totalPoint: 'Total Points'
    },
    header: 'Continuous Profressional Development',
    agentHeader: 'FC CPD Points',
    alert: {
      content: 'Create / Edit Success'
    },
    create: {
      header: 'Create Training'
    }
  }
}



// WEBPACK FOOTER //
// ./src/Adm/langs/en_us/index.js